import {
  Root,
  StyledInfoIcon,
  StyledTooltip,
  TooltipContainer,
} from './Label.ui';

type LabelProps = {
  children: React.ReactNode;

  tooltip?: string;
};

export const Label = (props: LabelProps) => {
  const { children, tooltip } = props;

  return (
    <Root>
      {children}
      {tooltip ? (
        <TooltipContainer>
          &#xfeff;
          <StyledTooltip text={tooltip}>
            <StyledInfoIcon aria-hidden="true" />
          </StyledTooltip>
        </TooltipContainer>
      ) : null}
    </Root>
  );
};
